module.exports = __webpack_public_path__ + "static/media/presentation.7416ad6c.pptx";